<template>
  <div>
    <h2>ຜົນການອອກເລກລາງວັນ</h2>
    <table class="table table-bordered">
      <tr>
        <td>ງວດວັນທີ່</td>
        <td>ເລກ 5 ໂຕ</td>
        <td>ເລກ 4 ໂຕ</td>
        <td>ເລກ 3 ໂຕ</td>
        <td>ເລກ 2 ໂຕ</td>
        <td>ເລກ 1 ໂຕ</td>
        <td>ເລກ 2 ພິເສດ</td>
      </tr>
      <tr v-for="(item, index) in items" :key="index">
        <td>{{ item.lotto_date | date }}</td>
        <td>{{ item.results | result('digit5') }}</td>
        <td>{{ item.results | result('digit4') }}</td>
        <td>{{ item.results | result('digit3') }}</td>
        <td>{{ item.results | result('digit2_top') }}</td>
        <td>{{ item.results | result('digit1') }}</td>
        <td>{{ item.results | result('digit2_special') }}</td>
      </tr>
    </table>
  </div>
</template>
<script>
import moment from "@/moment"

import LottoService from "@/services/lottoService"

export default {
  name: 'HistoryResults',
  data() {
    return {
      data: []
    }
  },
  computed: {
    items() {
      return this.data
    }
  },
  methods: {
    getResults() {
      LottoService.getHistories().then((response) => {
        if (response.status === 'success') {
          this.data = response.data
        }
      })
    }
  },
  created() {
    this.getResults()
  },
  filters: {
    date(param) {
      return moment(param).format("LL")
    },
    result(param, digit) {
      if (param) {
        let results = param
        return results[digit]
      } else {
        return '-'
      }
    }
  },
}

</script>
